<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    destroy-on-close
    @ok="submitForm"
    @cancel="onClose"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
      <a-form-model-item label="历史交易总额" prop="userTotalAmount">
        <a-input-number
          v-model="form.userTotalAmount"
          :min="0"
          :precision="2"
          :step="0.01"
          style="width: 100%"
          placeholder="请输入历史交易总额"
        />
      </a-form-model-item>
      <a-form-model-item label="钱包未提现余额" prop="money">
        <a-input-number
          v-model="form.money"
          :min="0"
          :precision="2"
          :step="0.01"
          style="width: 100%"
          placeholder="请输入钱包未提现余额"
        />
      </a-form-model-item>
      <a-form-model-item label="用户已提现总额" prop="totalWithdrawnAmount">
        <a-input-number
          v-model="form.totalWithdrawnAmount"
          :min="0"
          :precision="2"
          :step="0.01"
          style="width: 100%"
          placeholder="请输入用户已提现总额"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" type="textarea" :rows="2" placeholder="可选，记录修改原因" allow-clear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateUserAmounts } from '@/api/biz/user'

export default {
  name: 'EditAmounts',
  data() {
    return {
      open: false,
      submitLoading: false,
      title: '编辑金额',
      form: {
        id: null,
        userTotalAmount: 0,
        money: 0,
        totalWithdrawnAmount: 0,
        remark: ''
      },
      rules: {
        userTotalAmount: [{ required: true, message: '请输入历史交易总额', trigger: 'blur' }],
        money: [{ required: true, message: '请输入钱包未提现余额', trigger: 'blur' }],
        totalWithdrawnAmount: [{ required: true, message: '请输入用户已提现总额', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() {
      this.open = false
      this.submitLoading = false
    },
    handleOpen(record) {
      const name = (record && (record.nickname || record.email || record.id)) || ''
      this.title = `编辑金额 - ${name}`
      this.form = {
        id: record.id,
        userTotalAmount: Number(record.userTotalAmount || 0),
        money: Number(record.money || 0),
        totalWithdrawnAmount: Number(record.totalWithdrawnAmount || 0),
        remark: ''
      }
      this.open = true
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        updateUserAmounts({ ...this.form }).then(res => {
          if (res && (res.code == 20001 || res.code === '20001')) {
            this.$message.success('修改成功')
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error((res && res.message) || '修改失败')
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
